export const createUsageTrackerBody = (year: number, months: string[]) => {
    return {
        period: {
            year,
            months,
        },
    };
};
